import React, { useState } from 'react';
import styled from 'styled-components';
import { OlympiadsApi } from 'api';
import FileSaver from 'file-saver';
import { Space, Button } from '@gr-monorepo/common/ui';
import { useClickStreamContext } from 'features/shared/ClickStream';

export const DownloadPlate = styled.div`
  display: flex;
  align-items: center;
  background: rgba(9, 21, 38, 0.07);
  border-radius: 10px;
  padding: 24px 24px;

  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.85);
`;

const DownloadOlympiadSchedule = (props: { yearLearn: string }) => {
  const { logPageEvent } = useClickStreamContext();
  const [pendingDownload, setPendingDownload] = useState(false);
  const downloadPdf = async () => {
    if (pendingDownload) return;
    logPageEvent({
      eventType: 'olymp_download_schedule',
      eventInfo: `Олимпиада: Скачивание расписания`,
    });
    setPendingDownload(true);
    try {
      const blob = await OlympiadsApi.getOlympiadsPdf(
        `Расписание олимпиад на ${props.yearLearn}.pdf`,
        props.yearLearn.replace('/', '-'),
      );
      FileSaver.saveAs(blob, `Расписание олимпиад ${props.yearLearn}.pdf`);
    } catch (e) {}

    setPendingDownload(false);
  };
  return (
    <DownloadPlate data-qa-id="download_block">
      <span>Скачайте расписание олимпиад на этот учебный год, чтобы разослать школам</span>
      <Space size={69} axis={'horizontal'} />
      <Button onClick={downloadPdf} style={{ width: 185, flex: '0 0 auto' }} color="violet">
        {pendingDownload ? 'Скачивание' : 'СКАЧАТЬ'}
      </Button>
    </DownloadPlate>
  );
};

export default DownloadOlympiadSchedule;
